import {
  NULLABLE_FILTER_IS_NULL,
  NULLABLE_FILTER_QUERY_PARAMS,
} from "../constants/CustomerFilters";
import {
  CUSTOMER_STATUS_ACTIVE,
  CUSTOMER_STATUS_INACTIVE,
} from "../constants/CustomerStatus";
import {
  QUICK_FILTER_NO_PARENT,
  QUICK_FILTER_TEST,
} from "../constants/QuickFilters";

import type { CustomerFiltersType } from "../models/CustomerFilter";

export function prepareCustomerFilters({
  quickFilters = [],
  calculatedIntegrator = [],
  calculatedIntegratorNull = false,
  ...filters
}: Partial<CustomerFiltersType> = {}) {
  const statusFilters = quickFilters.filter(
    (filter) =>
      filter === CUSTOMER_STATUS_ACTIVE || filter === CUSTOMER_STATUS_INACTIVE
  );

  const hasSingleStatusFilter = statusFilters.length === 1;
  const isTestFilterSelected = quickFilters.includes(QUICK_FILTER_TEST);
  const isNoParentFilterSelected = quickFilters.includes(
    QUICK_FILTER_NO_PARENT
  );

  return {
    ...filters,
    ...(hasSingleStatusFilter && {
      active: statusFilters.includes(CUSTOMER_STATUS_ACTIVE),
    }),
    ...(isTestFilterSelected && { test: true }),
    ...(isNoParentFilterSelected && {
      [NULLABLE_FILTER_QUERY_PARAMS.parent]: NULLABLE_FILTER_IS_NULL,
    }),
    // "Not set" and specific integrators are mutually exclusive - a customer's
    // calculated integrator is either null or a value, so null wins when both
    // are somehow set.
    ...(calculatedIntegratorNull
      ? {
          [NULLABLE_FILTER_QUERY_PARAMS.calculatedIntegrator]:
            NULLABLE_FILTER_IS_NULL,
        }
      : calculatedIntegrator.length > 0 && { calculatedIntegrator }),
  };
}
